import { BoxProps } from 'component/base/Grid';
import type * as CSS from 'csstype';

export enum Padding {
  LARGE = 'large',
  SMALL = 'small',
}

export enum Width {
  FULL = 'full',
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum MarginLeft {
  NONE = 'none',
  LEFT_NAV = 'leftNav',
}

export type ContentError = React.LazyExoticComponent<() => JSX.Element>;

/**
 * An error component to be rendered in place of the content
 * children.
 */
export interface IContentError {
  error?: ContentError | null;
}

export interface IContentMarginLeft {
  marginLeftType?: MarginLeft;
}

export interface IContentPadding {
  paddingType?: Padding;
}

/**
 * Width to be applied to content container.
 */
export interface IContentWidth {
  widthType?: Width;
}

export type IContentLayoutContext = IContentPadding &
  IContentWidth &
  IContentMarginLeft;

/**
 * The props that will be updated via a layout context if connected via
 * a provider.
 */
export type IContentContext = IContentError & IContentLayoutContext;

export type IContentContainer = BoxProps &
  IContentPadding & { className?: string };

export type IContentContainerStyleProps = Omit<IContentContainer, 'padding'> & {
  marginLeftType: MarginLeft;
  paddingType: Padding;
  backgroundColor: CSS.Property.BackgroundColor;
  containerMargin?: CSS.Property.Margin;
  containerWidth?: CSS.Property.Width;
};

export type IContentInnerWidth = BoxProps & IContentWidth;
export type IContentInnerWidthStyleProps = Omit<IContentInnerWidth, 'width'> & {
  widthType: Width;
};

export interface IContentLayout extends IContentContext {
  children: React.ReactNode;
  className?: string;
  containerProps?: IContentContainer;
  widthProps?: IContentInnerWidth;
}
